import { FC, useState } from "react";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import api from "../../api";

export interface ForgotPassProps {
  className?: string;
}

const ForgotPass: FC<ForgotPassProps> = ({ className = "" }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();

  const [message, setMessage] = useState("");
  const [ errorMessage, setErrorMessage ] = useState("");

  const handleForgotPasswordSubmit = (data) => {
    api.forgotPassword(
      data, 
      (res) => {
        if (res.status === 200) {
          setMessage("If this email is registered, a reset link has been sent.");
        }
      },
      (error) => {
        setErrorMessage("Something went wrong.");
      }
    );
  };

  return (
    <div className={`nc-PageForgotPassword ${className}`} data-nc-id="PageForgotPassword">
      <Helmet>
        <title>Forgot Password</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Forgot Password
        </h2>
        <div className="max-w-md mx-auto space-y-6">
          {/* ERROR MESSAGE */}
          {errorMessage && 
            <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4" role="alert">
              <p className="font-bold">Error</p>
              <p>{ errorMessage }</p>
            </div>
          }
          {/* ERROR MESSAGE */}

          {/* SUCESS MESSAGE */}
          {message &&
            <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4" role="alert">
              <p className="font-bold">Success</p>
              <p>{ message }</p>
            </div>
          }
          {/* SUCESS MESSAGE */}
          <form onSubmit={handleSubmit(handleForgotPasswordSubmit)}>
            <div className="grid grid-cols-1 gap-6">
              <label className="block">
                <span className="text-neutral-800 dark:text-neutral-200">Email address</span>
                <Input
                  type="email"
                  name="email"
                  placeholder="example@example.com"
                  className="mt-1"
                  {...register( "email" )}
                />
                {errors.email && 
                  <span className="ml-1 mt-2 text-xs text-red-500">
                    {errors.email.message.toString()}
                  </span>
                }
              </label>
              <ButtonPrimary type="submit">Send Reset Link</ButtonPrimary>
            </div>
          </form>
          <span className="block text-center text-neutral-700 dark:text-neutral-300">
            Remember your password? {" "}
            <Link to="/login">Sign in</Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ForgotPass;
